import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { FacilityInvitationMessagesApi } from '../../../apis/InvitationApi/FacilityInvitationMessagesApi.ts';

export function useGetFacilityInvitationMessages(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.facilityInvitationMessages, facilityId],
        queryFn: () => FacilityInvitationMessagesApi.getByFacility(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
